export default __webpack_public_path__ + "static/media/salj.13f90e1b.jpg";